import get from "lodash.get";

export default function getLegendText(selectedBenchmark, customBenchmarks, t){

    const legendText = {
        title: "Percentile Rank",
        subtitle: "based on National Norms",
        red: t("common:nth_pr", {percentile: 25}),
        yellow: `25 - 75 ${t("common:PR")}`,
        green: t("common:nth_pr", {percentile: 75}),
    }

    if(!selectedBenchmark || !customBenchmarks) return legendText

    const isDistrictBenchmark = get(selectedBenchmark, "value", "").toLowerCase().includes('district')
    if (isDistrictBenchmark) {
        legendText.title = "District Rank";
        legendText.subtitle = "Based on top and bottom district cutlines"
        legendText.red = '"' + customBenchmarks.district.cutlines[0].label + '"';
        legendText.yellow = "In Between";
        legendText.green = '"' + customBenchmarks.district.cutlines[2].label + '"';
    }

    return legendText
}